require('./bootstrap');

import Vue from 'vue';
import Vuex from 'vuex';
import VueTheMask from 'vue-the-mask';

Vue.use(Vuex);
Vue.use(VueTheMask);

const store = new Vuex.Store({
    state: {
        item: {},
        rateio: {},
        itemAcao: [],
        listaCaps: {},
        depositos: {},
        transacao: { status: '', mensagem: '' },
        indicativos: { ativos: '', inativos: '' },
        somaRateio: 0,
        fornecedor: {},
        pacientes: {},
        pacientes_cx: {},
        relatorio_id: {},
        saldoRelAtual: '',
        nome_rel_paciente: ''
    },
    mutations: {
        setSomaRateio(state, valor) {
            state.somaRateio = valor
        },
        SET_ITEM(state, item) {
            state.item = item
        }
    }
});
Vue.filter('formatarValorBRGlobal', function (value) {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
})

Vue.filter('formatCurrency', function (value) {
    if (!value) return '0,00';
    
    // Converte string "5.000,50" para número, se necessário
    //let number = typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace(',', '.')) : value;

    // Formata para moeda brasileira (R$ 1.000,00)
    //return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
});

Vue.filter('formataDataGlobal', (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString.replace(' ', 'T'));

    return date.toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
});

Vue.filter('formataDataCxGlobal', (dateString) => {
    if (!dateString) return '';

    // Espera que o formato seja yyyy-MM-dd
    const parts = dateString.split('-');
    if (parts.length !== 3) return '';

    const [year, month, day] = parts;

    return `${day}/${month}/${year}`;
})


Vue.component('home-component', require('./components/Home.vue').default);
Vue.component('login-component', require('./components/Login.vue').default);
Vue.component('caps-component', require('./components/Caps.vue').default);
Vue.component('pacientes-component', require('./components/Pacientes.vue').default);
Vue.component('me-component', require('./components/Me.vue').default);
Vue.component('lancamentos-component', require('./components/Lancamentos.vue').default);
Vue.component('fornecedor-component', require('./components/Fornecedor.vue').default);
Vue.component('usuarios-component', require('./components/Usuarios.vue').default);
Vue.component('input-container-component', require('./components/InputContainer.vue').default);
Vue.component('table-component', require('./components/Table.vue').default);
Vue.component('card-component', require('./components/Card.vue').default);
Vue.component('modal-component', require('./components/Modal.vue').default);
Vue.component('alert-component', require('./components/Alert.vue').default);
Vue.component('paginate-component', require('./components/Paginate.vue').default);
Vue.component('lan-rateio-component', require('./components/LanRateio.vue').default);
Vue.component('auto-complete-component', require('./components/AutoComplete.vue').default);
Vue.component('lan-caixa-component', require('./components/LancamentosCaixa.vue').default);
Vue.component('relatorio-pacientes-caixa-component', require('./components/RelatorioPacientes.vue').default);
Vue.component('pacientes-caixa-component', require('./components/PacientesCaixa.vue').default);
Vue.component('lanrateio-caixa-component', require('./components/LanRateioCaixa.vue').default);
Vue.component('inventario-component', require('./components/Inventario.vue').default);
Vue.component('descricao-padrao-component', require('./components/DescricaoPadrao.vue').default);
Vue.component('relatorios-component', require('./components/Relatorios.vue').default);


const app = new Vue({
    el: '#app',
    store
});
